import { FC } from 'react';

const getComponentDisplayName = <TProps extends object>(WrappedComponent: FC<TProps>, name?: string) =>
    WrappedComponent.name || name || 'Component';

export { getComponentDisplayName };
